import React from "react";

const TeamCard = ({ team }) => {
  return (
    <div className="group flex flex-col items-center mx-3 w-40 flex-shrink-0 cursor-default">
      {/* Photo container */}
      <div className="relative w-36 h-36 rounded-2xl overflow-hidden shadow-md group-hover:shadow-xl transition-all duration-300">
        <img
          src={team?.imageUrl}
          alt={team?.Name}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        {/* Overlay on hover */}
        <div className="absolute inset-0 bg-indigo-900/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
      </div>

      {/* Text */}
      <div className="mt-3 text-center px-1">
        <p className="font-heading text-sm font-bold text-gray-900 leading-tight">{team?.Name}</p>
        <span className="inline-block mt-1.5 text-[10px] font-semibold text-indigo-600 bg-indigo-50 border border-indigo-100/80 px-3 py-0.5 rounded-full tracking-wide uppercase">
          {team?.description}
        </span>
      </div>
    </div>
  );
};

export default TeamCard;
